import { Avatar } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { User, UserStatus } from 'api/models';
import { Avatar as StyledAvatar } from 'components/atoms/avatar';
import { getUserLabel } from 'utils/get-user-label';
import { RemainingMembers, Seenby, SeenbyMessage, UserItem } from './styles';

interface Member {
  user: User;
  lastSeenCommentId?: number;
}
interface Props {
  seenUsers: Member[];
}

type UserAvatarProps = Member;

interface RemainingUsersAvatarProps {
  remainingUsers: Member[];
}

const UserAvatar: FC<UserAvatarProps> = ({ user }) => {
  return (
    <StyledAvatar
      size="small"
      src={user.photoUrl}
      userStatus={user.userStatus as UserStatus}
      name={getUserLabel(user)}
      key={user.userId}
    />
  );
};

const RemainingUsersAvatar: FC<RemainingUsersAvatarProps> = ({
  remainingUsers,
}) => {
  return (
    <RemainingMembers size="small">
      <FormattedMessage
        id="more_members_count"
        values={{
          count: remainingUsers.length,
        }}
      />
    </RemainingMembers>
  );
};

export const CommentSeenBy: FC<Props> = ({ seenUsers = [] }) => {
  const [firstFiveUsers, remainingUsers] = [
    seenUsers.slice(0, 5),
    seenUsers.slice(5),
  ];

  return (
    <Seenby
      title={
        <>
          <SeenbyMessage>
            <FormattedMessage id="projects.conversations.seen_till" />
          </SeenbyMessage>
          {seenUsers.map(({ user }) => (
            <UserItem key={user.userId}>{getUserLabel(user)}</UserItem>
          ))}
        </>
      }
      placement="top"
    >
      <div>
        <Avatar.Group>
          {firstFiveUsers.map(({ user }) => (
            <UserAvatar key={user.userId} user={user} />
          ))}
          {remainingUsers.length ? (
            <>
              <RemainingUsersAvatar remainingUsers={remainingUsers} />
            </>
          ) : null}
        </Avatar.Group>
      </div>
    </Seenby>
  );
};
